import React from 'react'
import * as PropTypes from 'prop-types'
import {InferPropTypes} from '@modifi/typescript-utils'
import TestimonialCard from './TestimonialCard'
import {TestimonialContainer, TestimonialContentContainer} from './styles'
import {DefaultComponentWrapper} from '../common'
import DefaultCarosel from '../../common-components/default-carousel'

const propTypes = {
  testimonials: PropTypes.arrayOf(
    PropTypes.shape({
      testimonial: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      position: PropTypes.string.isRequired,
      portrait: PropTypes.string,
    }).isRequired
  ),
  backgroundColor: PropTypes.string,
}
const defaultProps = {
  testimonials: [],
  backgroundColor: undefined,
}

export type TestimonialCarouselProps = InferPropTypes<typeof propTypes, typeof defaultProps>

export const TestimonialCarousel: React.FC<TestimonialCarouselProps> = ({
  testimonials,
  backgroundColor,
}) => (
  <TestimonialContainer fluid backgroundColor={backgroundColor}>
    <TestimonialContentContainer>
      <DefaultComponentWrapper>
        <DefaultCarosel indicatorPosition="left" cardAlignment="left" containerOverflow>
          {(testimonials ?? []).map((testimonial, i) => (
            // eslint-disable-next-line react/no-array-index-key
            <TestimonialCard key={i} {...testimonial} />
          ))}
        </DefaultCarosel>
      </DefaultComponentWrapper>
    </TestimonialContentContainer>
  </TestimonialContainer>
)

TestimonialCarousel.propTypes = propTypes

TestimonialCarousel.defaultProps = defaultProps

export default TestimonialCarousel
